<ng-container *ngIf="chargepoint$ | async as chargepoint">
  @switch (chargepoint?.type) {
    @case ('OCPP') {
      <app-ocpp-chargepoint-page [chargepoint]="$any(chargepoint)" (refresh)="refresh()"></app-ocpp-chargepoint-page>
    }
    @case ('OKECHARGE') {
      <app-okecharge-chargepoint-page [chargepoint]="$any(chargepoint)" (refresh)="refresh()"></app-okecharge-chargepoint-page>
    }
    @case ('IVY') {
      <app-ivy-chargepoint-page [chargepoint]="$any(chargepoint)" (refresh)="refresh()"></app-ivy-chargepoint-page>
    }
    @case ('NETATMO') {
      <div>Netatmo Chargepoint page not implemented yet</div>
    }
  }
</ng-container>